module.exports = __webpack_public_path__ + "static/media/illustration-calendar-checked.0293ea5f.svg";